<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title>Profil</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-title primary-title>
        <v-row>
          <v-col col="4">
            <v-avatar v-if="!photoPreview" size="64" class="mr-6">
              <img alt="user" :src="user.profile_photo_url">
            </v-avatar>
            <template
              v-if="$page.props.jetstream.managesProfilePhotos"
            >
              <v-avatar v-if="photoPreview" size="64" class="mr-6">
                <img alt="user" :src="photoPreview">
              </v-avatar>
              <v-btn v-if="user.profile_photo_path" @click="deletePhoto">
                Profilbild löschen
              </v-btn>
            </template>
          </v-col>
          <v-col>
            <v-file-input
              v-if="$page.props.jetstream.managesProfilePhotos"
              ref="photo"
              v-model="photoUpload"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="wähle ein neues Profilbild"
              prepend-icon="mdi-camera"
              label="neues Profilbild"
              @change="updatePhotoPreview"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          label="New Name"
          required
          class="form-control"
          type="name"
          name="name"

          :class="{ 'is-invalid': form.errors.name }"
          :error="form.errors.name"
          :error-messages="form.errors.name"
        />
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.email"
          label="New Email"
          required
          class="form-control"
          type="email"
          name="email"
          autocomplete="username"

          :class="{ 'is-invalid': form.errors.email }"
          :error="form.errors.email"
          :error-messages="form.errors.email"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
export default {
   props: {
      user: {
         type: Object,
         default: () => {},
      },
      twoFactor: {
         type: Boolean,
         default: false,
      },
   },
   data () {
      return {
         form: this.$inertia.form(
            {
               _method: 'put',
               name: null,
               email: null,
               photo: null,
            }
         ),
         photoUpload: null,
         photoPreview: null,
      }
   },
   created () {
      this.form.name = this.user.name
      this.form.email = this.user.email
   },
   methods: {
      save () {
         if (this.photoUpload) {
            this.form.photo = this.photoUpload
         }
         console.log(this.form)

         this.form.post(this.route('user-profile-information.update'), {
            preserveScroll: true
         })
      },
      updatePhotoPreview () {
         this.photoPreview = URL.createObjectURL(this.photoUpload)
      },
      deletePhoto () {
         this.$inertia
            .delete(this.route('current-user-photo.destroy'), {
               preserveScroll: true,
               onSuccess: () => {
                  this.photoPreview = null
               }
            })
      },
   },
}
</script>

<style>
</style>
